import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Col, Row, Tooltip } from 'antd';
import {
  Text,
  UnderlineLink,
  NoResult,
  SearchTableLabel,
  CustomTable,
  SubSectionLabelWDivider,
} from './style';
import TabsComponent from '../../../../../../CommonComponents/TabsComponent/TabsComponent';
import RecentCharities from '../RecentCharities/RecentCharities';
import pendingCharityColumns from './pendingCharityColumns';
import grantHistoryColumns from './grantHistoryColumns';
import GrantPopup from '../GrantPopup/GrantPopup';
import { tabPaneFuncton } from './config';
import Contents, {
  ContentProvider,
  ContentMessage,
  Types,
} from '../../../../../../CommonComponents/ContentMessages';
import { TabsPane } from '../../../../../../CommonComponents/TabsComponent/styles';
import RenderCard from '../RenderCard/RenderCard';
import Preloader from '../../../../../../CommonComponents/Preloader/Preloader';
import CharitySearch from '../../../../../../CommonComponents/CharitySearch/CharitySearch';
import MultipleCharityPopup from '../../../../../../CommonComponents/CharitySearch/Component/MultipleCharity/MultipleCharity';
import {
  SectionMediumDivider,
  GrantSectionHeading,
  UnderlyingContent,
  GrantSectionSubHeading,
  LinkToSamll,
  CharitySectionDivider,
  ScrollUp,
  FindCharitySectionHeading
} from '../../style';
import {
  fetchRecentGrant,
  fetchGrantHistory,
  fetchPendingGrant,
  selectCharity,
  removeCharity,
  fetchSavedCharity,
  showGeminiFilter,
  searchGemini,
  postSavedCharity,
  addCharity,
  postSavedGemini,
  cancelSaveCharity,
  newGrant,
} from '../../actions';
import SearchTable from '../SearchTable/SearchTable';
import { SectionContent } from '../../../../../../CommonComponents/commonStyles';
import WorkBookPrintGrant from './WorkBookPrint';
import { EndResult } from '../SearchTable/style';
import ErrorPopup from '../../../../../../CommonComponents/ErrorPopup/ErrorPopup';
import FlowFooter from './../FlowFooter/FlowFooter';
import { getPrimaryAccount } from '../../../../../../utils/sessionUtil';
import { addressFormat } from '../../utils';
import PrintTable from '../../../../../../CommonComponents/PrintTable/PrintTable';
import {
  replaceAnchorWithLink,
  charityEligibilityChecker,
  recordError,
} from '../../../../../../utils/commonUtil';
import DrupalPopup from '../Popup/DrupalPopup';

import { charitySelectDerivedStates } from '../../Selectors/CharitySelectSelectors';

const { TabPane } = TabsPane;
export class CharitySelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showGrantHistory: false,
      showPendingCharity: false,
      showScheduleHistory: false,
      selectedCharity: {},
      showGeminiFilter: false,
      showRemoveCharityPopup: false,
      activeTab: '2',
      frozen: false,
      multipleCharities: [],
      eligible: true,
      partialEligibility: false,
    };
    this.multipleCharitySaveHandler = this.multipleCharitySaveHandler.bind(
      this
    );
  }

  componentDidMount() {
    // Remove from menu state if component has mount cycle, the component will be rendered in new state
    // bugfix - 5970
    if (this.props.location.state && this.props.location.state.fromMenu) {
      this.removeMenuState();
    }
    this.fetchData();
    if (getPrimaryAccount().freezes && getPrimaryAccount().freezes.length > 0) {
      this.setState({
        frozen: true,
      });
    }
  }

  componentDidUpdate(prevProps) {
    // If on recommend grant page and clicking on header item the page should reset to initial state
    // bugfix - 5970
    if (
      prevProps.location.pathname === this.props.location.pathname &&
      this.props.location.state &&
      this.props.location.state.fromMenu
    ) {
      this.removeMenuState();
      this.props.newGrant();
      this.fetchData();
    }
  }

  removeMenuState = () => {
    const stateCopy = { ...this.props.location.state };
    delete stateCopy.fromMenu;
    this.props.history.replace({ state: stateCopy });
  };

  fetchData = () => {
    const { accountId } = this.props;
    this.getRecentGrants(accountId);
    this.getSavedCharity(accountId);
  };

  getRecentGrants = (accountId) => {
    this.props.fetchRecentGrant({
      method: 'GET',
      url: `/donor-portal/api/grant/${accountId}/findRecentlyGrantedCharitiesbyAccountId`,
      page: 'recommendGrant',
    });
  };

  getSavedCharity = (accountId) => {
    this.props.fetchSavedCharity({
      method: 'GET',
      url: `/donor-portal/api/granteeOrg/${accountId}/getAllCharityByAccountId`,
      page: 'recommendGrant',
    });
  };

  getGrantHistory = (accountId, charityId) => {
    this.props.fetchGrantHistory({
      method: 'GET',
      url: `/donor-portal/api/grant/${accountId}/findGrantsByAccountIdandCharityIdandGrantStatus?charityId=${charityId}&grantStatus=all`,
      page: 'recommendGrant',
    });
  };

  grantHistoryHandler = (record) => {
    this.getGrantHistory(this.props.accountId, record.charityId);
    this.setState({
      showGrantHistory: true,
      selectedCharity: { ...this.formatCharity(record) },
    });
  };

  scheduleHistoryHandler = (record) => {
    this.getGrantHistory(this.props.accountId, record.charityId);
    this.setState({
      showScheduleHistory: true,
      selectedCharity: { ...this.formatCharity(record) },
    });
  };

  getPendingGrant = (accountId, charityId) => {
    this.props.fetchPendingGrant({
      method: 'GET',
      url: `/donor-portal/api/grant/${accountId}/findGrantsByAccountIdandCharityIdandGrantStatus?charityId=${charityId}&grantStatus=pending`,
      page: 'recommendGrant',
    });
  };

  // Handler for select of recently granted or saved charities
  pendingCharityHandler = (record) => {
    const { analyticsHandler, accountId } = this.props;
    if (record.isPending) {
      this.getPendingGrant(accountId, record.charityId);
      this.setState({
        showPendingCharity: true,
        selectedCharity: { ...this.formatCharity(record) },
      });
    } else {
      analyticsHandler &&
        analyticsHandler('select', record.charityName, 'Select');
      this.selectCharity(this.formatCharity(record));
    }
  };

  addSelectedCharity = (data, successFn) => {
    const { accountId } = this.props;
    this.props.addCharity(
      {
        userId: accountId,
        charityData: {
          granteeOrgId: data.granteeOrgId,
          alias: data.legalName,
        },
      },
      data,
      successFn
    );
  };

  // Handler for select of search results
  searchSelectHandler = (record, formatFn, gemini) => {
    const { accountId } = this.props;
    if (record.isPending) {
      this.getPendingGrant(accountId, record.charityId);
      this.setState({
        showPendingCharity: true,
        selectedCharity: { ...formatFn(record) },
      });
    } else if (record.isSelected) {
      this.selectCharity(formatFn(record));
    } else if (gemini) {
      this.saveGeminiCharity(record, () =>
        this.selectCharity(formatFn(record))
      );
    } else {
      this.saveCharity(record, this.multipleCharitySaveHandler);
    }
  };

  saveCharity = (record, successFn) => {
    const { accountId } = this.props;
    let recordToSave = {
      ein: record.ein,
      legalName: record.organization_name,
      addressLine1: record.address_line_1,
      addressLine2: record.address_line_2,
      addressLine3: '',
      state: record.state,
      city: record.city,
      country: 'US',
      zip: record.zip,
      charityContactFirstName: record.contact_name,
      charityContactLastName: '',
      email: record.contact_email,
      phoneNumber: record.contact_phone,
    };
    this.setState({
      saveCharityData: {
        userId: accountId,
        charityData: recordToSave,
      },
      guideStarSelectedCharity: record,
    });
    const eligibility = charityEligibilityChecker({
      pub78: record.properties.pub78_verified,
      bmfStatus: record.properties.bmf_status,
      subSection: record.subsection_code,
      foundationCode: record.foundation_code,
    });
    if (eligibility.mandatory && eligibility.partial) {
      this.props.postSavedCharity(
        {
          userId: accountId,
          charityData: recordToSave,
        },
        (response) => successFn(response, record)
      );
    } else if (eligibility.mandatory && !eligibility.partial) {
      this.setState({ partialEligibility: true });
    } else {
      this.setState({ eligible: false });
    }
  };

  saveInEligibleCharities = () => {
    if (this.state.partialEligibility === true) {
      this.setState({ partialEligibility: false });
    } else {
      this.setState({ eligible: true });
    }
    this.props.postSavedCharity(this.state.saveCharityData, (response) =>
      this.multipleCharitySaveHandler(
        response,
        this.state.guideStarSelectedCharity
      )
    );
  };

  saveGeminiCharity = (data, successFn) => {
    this.props.postSavedGemini(
      {
        userId: getPrimaryAccount().userId,
        charityData: {
          granteeOrgId: data.granteeOrgId,
          alias: data.legalName,
        },
      },
      successFn
    );
  };

  multipleCharitySaveHandler = (savedRecord, reqRecord) => {
    if (savedRecord.isExisting) {
      if (savedRecord.granteeOrgs && savedRecord.granteeOrgs.length === 1) {
        // add charity directly and proceed
        this.saveSelectedCharity(savedRecord.granteeOrgs[0]);
      } else if (
        savedRecord.granteeOrgs &&
        savedRecord.granteeOrgs.length > 1
      ) {
        // show multiple charity popup
        // if user tries to save multiple with ein conflict, keep first cancel rest
        if (!Object.keys(this.state.selectedCharity).length) {
          this.setState({
            multipleCharities: savedRecord.granteeOrgs,
            selectedCharity: { ...reqRecord },
          });
        } else {
          this.props.cancelSaveCharity(reqRecord);
        }
      }
    } else {
      this.selectCharity(this.formatCharity(savedRecord));
    }
  };

  saveSelectedCharity = (charity) => {
    this.addSelectedCharity(charity, () =>
      this.selectCharity(this.formatSuggestedCharity(charity))
    );
    this.setState({
      multipleCharities: [],
      selectedCharity: {},
    });
  };

  selectCharity = (record) => {
    const charityRefLink = this.props.location.pathname;
    this.props.selectCharity(record, charityRefLink);
    if (this.props.editMode) {
      this.props.onUpdate();
    } else {
      // redirect to step1a
      this.props.history.push('/grants/recommend/charity-purpose');
    }
  };

  onCancelGrantHistory = () => {
    this.setState({
      showGrantHistory: false,
      selectedCharity: {},
    });
  };

  onCancelScheduleHistory = () => {
    this.setState({
      showScheduleHistory: false,
      selectedCharity: {},
    });
  };

  onCancelPendingCharity = () => {
    this.setState({
      showPendingCharity: false,
      selectedCharity: {},
    });
  };

  onCancelMultipleCharity = () => {
    this.props.cancelSaveCharity(this.state.selectedCharity);
    this.setState({
      multipleCharities: [],
      selectedCharity: {},
    });
  };

  makeGrant = () => {
    const { analyticsHandler } = this.props;
    const { selectedCharity } = this.state;
    analyticsHandler &&
      analyticsHandler('select', selectedCharity.name, 'Select');
    this.selectCharity(selectedCharity);
  };

  // Different formatting needed as different structures from backend api
  formatCharity = (charity) => ({
    ein: charity.ein,
    name: charity.charityName,
    address: {
      addressLine1: charity.addressLine1,
      addressLine2: charity.addressLine2,
      addressLine3: charity.addressLine3,
      city: charity.city,
      state: charity.state,
      zipCode: charity.zip,
    },
    id: charity.charityId,
    interestArea: charity.interestArea,
  });

  formatSearchResult = (charity) => ({
    ein: charity.ein,
    name: charity.organization_name,
    address: {
      addressLine1: charity.address_line_1,
      addressLine2: charity.address_line_2,
      city: charity.city,
      state: charity.state,
      zipCode: charity.zip,
    },
    id: charity.charityId,
    interestArea: charity.ntee_code,
  });

  formatSuggestedCharity = (charity) => ({
    ein: charity.ein,
    name: charity.legalName,
    address: {
      addressLine1: charity.addressLine1,
      addressLine2: charity.addressLine2,
      addressLine3: charity.addressLine3,
      city: charity.city,
      state: charity.state,
      zipCode: charity.zip,
    },
    id: charity.granteeOrgId,
    interestArea: charity.interestArea,
  });

  formatGeminiResult = (charity) => ({
    ein: charity.ein,
    name: charity.legalName,
    address: {
      addressLine1: charity.addressLine1,
      addressLine2: charity.addressLine2,
      addressLine3: charity.addressLine3,
      city: charity.city,
      state: charity.state,
      zipCode: charity.zip,
    },
    id: charity.granteeOrgId,
    interestArea: charity.interestArea,
  });

  // charity id here is the alias id
  removeCharity = (charityId) => {
    this.props.removeCharity(
      {
        method: 'POST',
        url: `/donor-portal/api/grant/${this.props.accountId}/removeCharity?granteeOrgAliasId=${charityId}`,
        page: 'recommendGrant',
        charityId: charityId,
        searchType: this.state.showGeminiFilter ? 'gemini' : 'guidestar',
      },
      () => {
        this.getSavedCharity(this.props.accountId);
      }
    );
  };

  removeSavedCharity = (e, record) => {
    // call api to remove or add  a charity
    this.setState({
      showRemoveCharityPopup: true,
      selectedCharity: { ...record },
    });
  };

  cancelRemoveCharity = () => {
    this.setState({
      showRemoveCharityPopup: false,
      selectedCharity: {},
    });
  };

  handleTabChange = (activeTabKey) => {
    const { analyticsHandler, stepDesc } = this.props;
    const tabContents = [...tabPaneFuncton()];
    analyticsHandler &&
      analyticsHandler(
        `${stepDesc ? 'tabsStep' : 'tabClick'}`,
        `${stepDesc ? `Step 1 ${stepDesc}` : ``}`,
        tabContents[activeTabKey - 1].title
      );
    this.setState({
      activeTab: activeTabKey,
    });
  };

  viewGrants = (id, type) => {
    try {
      if (type === 'single') {
        this.props.history.push(`/grants/activity/view?grantId=${id}`);
      } else if (type === 'agreement') {
        this.props.history.push(
          `/grants/grants-agreement/view?grantAgreementId=${id}`
        );
      } else {
        this.props.history.push(`/grants/activity/view?scheduleId=${id}`);
      }
    } catch (error) {
      recordError(error);
    }
  };

  grantActivityClickHandler = () => {
    this.props.history.push('/grants/activity');
  };

  renderRemoveCharityPopup = (charity) => {
    return (
      <ErrorPopup
        title="Sure you want to remove this charity?"
        secondaryCta={this.cancelRemoveCharity}
        primaryCtaLabel="Continue"
        primaryCta={() => {
          this.setState({
            showRemoveCharityPopup: false,
            selectedCharity: {},
          });
          this.removeCharity(charity.granteeOrgAliasId);
        }}
        show
      >
        <SectionContent>{`Note: Removing ${charity.charityName} from your 'Saved Charities' wouldn't affect any pending grant or recurring schedule`}</SectionContent>
      </ErrorPopup>
    );
  };

  renderCardComponent = (data = [], functionObj, componentName) => {
    return data.map((cardData, index) => {
      return (
        <RenderCard
          key={`${componentName}${index}`}
          index={index}
          data={cardData}
          component={componentName}
          {...functionObj}
        />
      );
    });
  };

  renderGeminiFilter = () => {
    try {
      this.props.searchGemini({
        method: 'GET',
        url: '/search_gemini',
        page: 'recommendGrant',
        isExternal: true,
      });
      this.setState(
        {
          showGeminiFilter: true,
        },
        () => this.props.showGeminiFilter(this.state.showGeminiFilter)
      );
    } catch (error) {
      recordError(error);
    }
  };

  renderGuidestarFilter = () => {
    try {
      this.setState(
        {
          showGeminiFilter: false,
        },
        () => this.props.showGeminiFilter(this.state.showGeminiFilter)
      );
    } catch (error) {
      recordError(error);
    }
  };

  suggestACharity() {
    try {
      this.props.history.push({
        pathname: '/suggest-a-charity',
      });
    } catch (error) {
      recordError(error);
    }
  }

  renderSearchCharityTable = () => {
    return (
      <>
        {this.props.searchCharity.length === 0 ? (
          <SearchTableLabel
            className={window.innerWidth < 767 ? 'scrollUp' : ''}
          >
            Displaying {this.props.searchCharity.length} of{' '}
            {this.props.searchCharity.length} search results{' '}
            {this.props.searchTermData
              ? 'for' + ' ' + this.props.searchTermData
              : null}
          </SearchTableLabel>
        ) : (
          <SearchTableLabel
            className={window.innerWidth < 767 ? 'scrollUp' : ''}
          >
            Displaying {this.props.searchCharity.length} of{' '}
            {this.props.guidestarSearchCount} search results{' '}
            {this.props.searchTermData
              ? 'for' + ' ' + this.props.searchTermData
              : null}
          </SearchTableLabel>
        )}
        <Text>
          Can't find your charity?&nbsp;Search&nbsp;
          <UnderlineLink
            id="anrVanguardCharitable"
            onClick={this.renderGeminiFilter}
          >
            Vanguard Charitable
          </UnderlineLink>{' '}
          or&nbsp;
          {this.state.frozen ? (
            <Tooltip
              placement="top"
              title="This account is frozen. Contact us at 888-383-4483."
            >
              <UnderlineLink id="anrSuggestACharityFrozen">
                Suggest a charity
              </UnderlineLink>
            </Tooltip>
          ) : (
            <UnderlineLink
              id="anrSuggestACharity"
              onClick={this.suggestACharity.bind(this)}
            >
              Suggest a charity
            </UnderlineLink>
          )}
        </Text>
        <ScrollUp />
        {(this.props.searchCharity.length > 0 && !this.props.serverDown) ? (
          <SearchTable
            isFindACharity={this.props.findCharity ? true : false}
            columnData={this.props.searchCharity}
            guidestarSearchCount={this.props.guidestarSearchCount}
            showGeminiFilter={this.state.showGeminiFilter}
            pendingCharityHandler={(record) =>
              this.searchSelectHandler(record, this.formatSearchResult)
            }
            removeSavedCharity={this.removeCharity}
            getSavedCharity={this.getSavedCharity}
            addCharity={this.addSelectedCharity}
            saveCharity={this.saveCharity}
            saveGeminiCharity={this.saveGeminiCharity}
            activityBlocked={this.props.activityBlocked}
          />
        ) : (this.props.searchCharity.length === 0 && this.props.serverDown) ? (
          <NoResult>The system is temporarily unavailable</NoResult>
        ) : (
          <NoResult>Charity not found.</NoResult>
        )}
      </>
    );
  };

  renderSearchGeminiTable = () => {
    if (this.props.searchGeminiStringResponse) {
      return (
        <>
          <NoResult>
            The search results have exceeded the maximum limit of 500 records.
            Please refine your search criteria and try again.
          </NoResult>
          <CharitySectionDivider />
          <Text>
            Can't find your charity?&nbsp;Search&nbsp;
            <UnderlineLink
              id="anrGuideStar"
              onClick={this.renderGuidestarFilter}
            >
              GuideStar
            </UnderlineLink>{' '}
            or&nbsp;
            {this.state.frozen ? (
              <Tooltip
                placement="top"
                title="This account is frozen. Contact us at 888-383-4483."
              >
                <UnderlineLink id="anrSearchGeminiSuggestACharityFrozen">
                  Suggest a charity
                </UnderlineLink>
              </Tooltip>
            ) : (
              <UnderlineLink
                id="anrSearchGeminiSuggestACharity"
                onClick={this.suggestACharity.bind(this)}
              >
                Suggest a charity
              </UnderlineLink>
            )}
          </Text>
        </>
      );
    }
    return (
      <>
        <SearchTableLabel>
          Displaying {this.props.searchGeminiData.length} of{' '}
          {this.props.searchGeminiData.length} search results{' '}
          {this.props.geminiSearchTerm
            ? 'for' + ' ' + this.props.geminiSearchTerm
            : null}
        </SearchTableLabel>
        <Text>
          Can't find your charity?&nbsp; Search&nbsp;
          <UnderlineLink id="anrGuideStar" onClick={this.renderGuidestarFilter}>
            GuideStar
          </UnderlineLink>{' '}
          &nbsp; or&nbsp;
          {this.state.frozen ? (
            <Tooltip
              placement="top"
              title="This account is frozen. Contact us at 888-383-4483."
            >
              <UnderlineLink id="anrToolTipSuggestACharityFrozen">
                Suggest a charity
              </UnderlineLink>
            </Tooltip>
          ) : (
            <UnderlineLink
              id="anrToolTipSuggestACharity"
              onClick={this.suggestACharity.bind(this)}
            >
              Suggest a charity
            </UnderlineLink>
          )}
        </Text>
        <ScrollUp />

        {this.props.searchGeminiData.length > 0 ? (
          <SearchTable
            isFindACharity={this.props.findCharity ? true : false}
            columnData={this.props.searchGeminiData}
            showGeminiFilter={this.state.showGeminiFilter}
            pendingCharityHandler={(record) =>
              this.searchSelectHandler(record, this.formatGeminiResult, true)
            }
            removeSavedCharity={this.removeCharity}
            getSavedCharity={this.getSavedCharity}
            addCharity={this.addSelectedCharity}
            saveCharity={this.saveCharity}
            saveGeminiCharity={this.saveGeminiCharity}
            activityBlocked={this.props.activityBlocked}
          />
        ) : (
          <NoResult>Charity not found.</NoResult>
        )}
      </>
    );
  };

  renderSearchCharity = () => {
    return this.props.isCharitySearch ? this.renderSearchCharityTable() : '';
  };

  renderSearchGemini = () => {
    return this.props.isGeminiSearch ? this.renderSearchGeminiTable() : '';
  };

  renderSelectedCharity = () => {
    const {
      savedCharities = [],
      recentGrants = [],
      isCharitySearch,
      activityBlocked = false,
    } = this.props;
    const tabConfig = function destObj(data, columnConfig) {
      return [
        {
          render: <RecentCharities data={data} column={columnConfig} />,
        },
        {
          render: <RecentCharities data={data} column={columnConfig} />,
        },
      ];
    };

    return isCharitySearch ? (
      ''
    ) : (
      <>
        <Row>
          <GrantSectionHeading>Select from your charities</GrantSectionHeading>
        </Row>
        <WorkBookPrintGrant
          workbookId="rag-charity"
          showGrantHistory={this.state.showGrantHistory}
          showPendingCharity={this.state.showPendingCharity}
          recentGrants={recentGrants}
          savedCharities={savedCharities}
          activeTab={this.state.activeTab}
          printProps={tabPaneFuncton(
            recentGrants,
            savedCharities,
            this.grantHistoryHandler,
            this.pendingCharityHandler,
            this.removeSavedCharity,
            this.scheduleHistoryHandler
          )}
          analyticsHandler={this.props.analyticsHandler}
        />
        <Row>
          <Col lg={24} md={0} xs={0}>
            <TabsComponent
              tabPanes={tabPaneFuncton(
                recentGrants,
                savedCharities,
                this.grantHistoryHandler,
                this.pendingCharityHandler,
                this.removeSavedCharity,
                this.scheduleHistoryHandler,
                activityBlocked
              )}
              activeKey="2"
              tabConfig={tabConfig}
              containerHeight="initial"
              getChange={this.handleTabChange}
            />
          </Col>
          <Col lg={0} md={24} xs={24}>
            <TabsPane
              id="tbSelectFromYourCharity"
              defaultActiveKey="2"
              onChange={this.handleTabChange}
            >
              <TabPane
                id="tbCharitiesRecentlySupported"
                tab="Charities recently supported"
                key="1"
                style={{ padding: '16px 18px 9px 18px !important' }}
              >
                {recentGrants && recentGrants.length ? (
                  this.renderCardComponent(
                    recentGrants,
                    {
                      grantHistoryHandler: this.grantHistoryHandler,
                      pendingCharityHandler: this.pendingCharityHandler,
                      scheduleHistoryHandler: this.scheduleHistoryHandler,
                      activityBlocked,
                    },
                    'RecentCharityCard'
                  )
                ) : (
                  <div className="noDataPlacement">
                    <div>No recent supported charities found</div>
                  </div>
                )}
              </TabPane>
              <TabPane
                id="tbYourSavedCharities"
                tab="Your saved charities"
                key="2"
                style={{ padding: '16px 18px 9px 18px !important' }}
              >
                {savedCharities && savedCharities.length ? (
                  this.renderCardComponent(
                    savedCharities,
                    {
                      pendingCharityHandler: this.pendingCharityHandler,
                      removeSavedCharity: this.removeSavedCharity,
                      activityBlocked,
                    },
                    'SavedCharityCard'
                  )
                ) : (
                  <div className="noDataPlacement">
                    <div>No saved charities found</div>
                  </div>
                )}
              </TabPane>
            </TabsPane>
          </Col>
        </Row>
        {this.props.searchCharity.length === this.props.guidestarSearchCount ? (
          <EndResult>You have reached the end of search results.</EndResult>
        ) : (
          <></>
        )}
      </>
    );
  };

  renderScheduleHistory = (scheduleHistory) => {
    return (
      <>
        <SubSectionLabelWDivider>Schedule IDs</SubSectionLabelWDivider>
        <Row>
          {scheduleHistory.map((schedule) => (
            <Col className="mb-30" lg={4} span={12} key={schedule.scheduleId}>
              <UnderlyingContent
                id="anrRecurringScheduleId"
                onClick={() =>
                  this.viewGrants(schedule.scheduleId, 'recurring')
                }
              >
                {'#' + schedule.scheduleId}
              </UnderlyingContent>
            </Col>
          ))}
        </Row>
      </>
    );
  };

  render() {
    const {
      isLoadingGranted,
      isLoadingSaved,
      grantHistory,
      pendingGrants,
      pendingActiveSchedule,
      scheduleHistory,
      pendingGrantsLoading,
      grantHistoryLoading,
      pendingAgreements,
      agreementHistory,
      findCharity,
    } = this.props;
    const {
      showGrantHistory,
      showPendingCharity,
      selectedCharity,
      showRemoveCharityPopup,
      showGeminiFilter,
      showScheduleHistory,
      multipleCharities,
    } = this.state;

    let charityAddress = '';
    if (selectedCharity && selectedCharity.address) {
      charityAddress = addressFormat(selectedCharity.address);
    }

    if (isLoadingGranted || isLoadingSaved) return <Preloader />;
    return (
      <ContentProvider
        types={[Types.PAGE_TITLE_DESCRIPTION, Types.PAGE_ALERTS]}
        pages={['Find a charity', 'Recommend a Grant']}
      >
        <Row>
          <FindCharitySectionHeading findCharity={this.props.findCharity}>
            <ContentMessage
              type={[Types.PAGE_TITLE_DESCRIPTION]}
              page="Find a charity"
              property="field_page_title"
              defaultMessage="Find a charity"
            />
          </FindCharitySectionHeading>
          <GrantSectionSubHeading>
            <Contents.Consumer data-test='Contents.Consumer'>
              {(props) => {
                if (
                  props.page_title_description &&
                  props.page_title_description['Find a charity']
                ) {
                  const PageData = replaceAnchorWithLink(
                    props.page_title_description['Find a charity']
                      .description__value,
                    'link',
                    '',
                    'How it works'
                  );
                  return PageData.map((data) => {
                    if (typeof data === 'string') {
                      return (
                        <span dangerouslySetInnerHTML={{ __html: data }}></span>
                      );
                    } else {
                      return (
                        <LinkToSamll id="anrFindACharityData">
                          {data}
                        </LinkToSamll>
                      );
                    }
                  });
                }
              }}
            </Contents.Consumer>
          </GrantSectionSubHeading>

          <CharitySearch fromPage="RAG" isFull={this.props.isFull} />
        </Row>
        <CharitySectionDivider />
        {this.renderSelectedCharity()}
        {!showGeminiFilter ? (
          <Row>{this.renderSearchCharity()}</Row>
        ) : (
          <Row>{this.renderSearchGemini()}</Row>
        )}
        {showGrantHistory && (
          <GrantPopup
            popupTitle="Grant History"
            grantName={selectedCharity.name}
            grantAddress={charityAddress}
            grantEin={selectedCharity.ein}
            schedule={scheduleHistory}
            agreements={agreementHistory}
            history
            show={showGrantHistory}
            onCancel={this.onCancelGrantHistory}
            grantActivityClick={this.grantActivityClickHandler}
            grantDetailsHandler={this.viewGrants}
            loading={grantHistoryLoading}
            singleCta
            ctaLabel="Close"
            renderPrint={
              <PrintTable
                grantHistoryPendingAlert={true}
                dataSource={grantHistory}
                columns={grantHistoryColumns(this.viewGrants)}
              />
            }
            renderDesktop={
              <CustomTable
                sidePadding
                dataSource={grantHistory}
                columns={grantHistoryColumns(this.viewGrants)}
                pagination={false}
              />
            }
            renderMobile={
              grantHistory &&
              grantHistory.map((data, index) => (
                <RenderCard
                  key={data.ein}
                  data={data}
                  index={index}
                  type="history"
                  grantDetailsHandler={this.viewGrants}
                  component="PopupCard"
                />
              ))
            }
          />
        )}
        {showPendingCharity && (
          <GrantPopup
            popupTitle="Pending grant alert"
            popupDesc="Pending grant(s) for the charity selected already exists."
            grantName={selectedCharity.name}
            grantAddress={charityAddress}
            grantEin={selectedCharity.ein}
            show={showPendingCharity}
            onCancel={this.onCancelPendingCharity}
            primaryCta={this.makeGrant}
            schedule={pendingActiveSchedule}
            agreements={pendingAgreements}
            grantActivityClick={this.grantActivityClickHandler}
            grantDetailsHandler={this.viewGrants}
            loading={pendingGrantsLoading}
            primaryCtaLabel="Yes, Make A New Grant"
            secondaryCtaLabel="No,take me back"
            renderPrint={
              <PrintTable
                grantHistoryPendingAlert={true}
                dataSource={pendingGrants}
                columns={pendingCharityColumns(this.viewGrants)}
              />
            }
            renderDesktop={
              <CustomTable
                sidePadding
                dataSource={pendingGrants}
                columns={pendingCharityColumns(this.viewGrants)}
                pagination={false}
              />
            }
            renderMobile={
              pendingGrants &&
              pendingGrants.map((data, index) => (
                <RenderCard
                  key={data.ein}
                  data={data}
                  index={index}
                  type="pending"
                  grantDetailsHandler={this.viewGrants}
                  component="PopupCard"
                />
              ))
            }
          />
        )}
        {showScheduleHistory && (
          <GrantPopup
            popupTitle="Grant Schedules"
            grantName={selectedCharity.name}
            grantAddress={charityAddress}
            grantEin={selectedCharity.ein}
            show={showScheduleHistory}
            onCancel={this.onCancelScheduleHistory}
            grantDetailsHandler={this.viewGrants}
            loading={grantHistoryLoading}
            singleCta
            ctaLabel="Close"
            renderDesktop={this.renderScheduleHistory(scheduleHistory)}
            renderMobile={this.renderScheduleHistory(scheduleHistory)}
          />
        )}
        {showRemoveCharityPopup &&
          this.renderRemoveCharityPopup(selectedCharity)}
        {multipleCharities.length ? (
          <MultipleCharityPopup
            show={!!multipleCharities.length}
            charities={multipleCharities}
            secondaryCta={this.onCancelMultipleCharity}
            primaryCta={this.saveSelectedCharity}
          />
        ) : (
          ''
        )}
        {this.props.editMode && (
          <>
            <SectionMediumDivider smallMarginTop />
            <FlowFooter
              edit="true"
              cancelFitWidth={true}
              updateCancelLabel="BACK TO REVIEW & SUBMIT"
              handleUpdateCancel={this.props.onUpdateCancel}
            />
          </>
        )}
        <DrupalPopup
          html={true}
          page={findCharity ? 'Find a charity' : 'Recommend a Grant'}
          show={!this.state.eligible}
          defaultPrimaryLabel={'Ok'}
          defaultSecondaryLabel={'Cancel'}
          defaultTitle={'Warning'}
          keyProperty={'Ineligible'}
          data-test='cta'
          defaultDescription={'you are ineligible'}
          primaryCta={this.saveInEligibleCharities}
          secondaryCta={() => this.setState({ eligible: true })}
          alertId="rag-ineligible"
        />
        <DrupalPopup
          html={true}
          page={findCharity ? 'Find a charity' : 'Recommend a Grant'}
          show={this.state.partialEligibility}
          defaultPrimaryLabel={'Ok'}
          defaultSecondaryLabel={'Cancel'}
          defaultTitle={'Warning'}
          data-test='cta1'
          keyProperty={'Partial Eligible'}
          defaultDescription={'you are ineligible'}
          primaryCta={this.saveInEligibleCharities}
          secondaryCta={() => this.setState({ partialEligibility: false })}
          alertId='rag-partial-eligible'
        />
      </ContentProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  ...charitySelectDerivedStates(state.toJS()),
});

export const mapDispatchToProps = (dispatch) => ({
  fetchRecentGrant: (data) => dispatch(fetchRecentGrant(data)),
  fetchGrantHistory: (data) => dispatch(fetchGrantHistory(data)),
  fetchPendingGrant: (data) => dispatch(fetchPendingGrant(data)),
  showGeminiFilter: (data) => dispatch(showGeminiFilter(data)),
  searchGemini: (data) => dispatch(searchGemini(data)),
  selectCharity: (charity, link) =>
    dispatch(selectCharity({ ...charity, charityRefPath: link })),
  removeCharity: (data, successFn) => dispatch(removeCharity(data, successFn)),
  fetchSavedCharity: (data) => dispatch(fetchSavedCharity(data)),
  postSavedCharity: (data, successFn) =>
    dispatch(postSavedCharity(data, successFn)),
  addCharity: (data, selectedCharity, successFn) =>
    dispatch(addCharity(data, selectedCharity, successFn)),
  postSavedGemini: (data, successFn) =>
    dispatch(postSavedGemini(data, successFn)),
  cancelSaveCharity: (data) => dispatch(cancelSaveCharity(data)),
  newGrant: (data) => dispatch(newGrant(data)),
});

CharitySelect.propTypes = {
  accountId: PropTypes.string.isRequired,
  allocationType: PropTypes.string,
  analyticsHandler: PropTypes.func,
  editMode: PropTypes.bool,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  newGrant: PropTypes.func,
  onUpdate: PropTypes.func,
  onUpdateCancel: PropTypes.func,
  stepDesc: PropTypes.string,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CharitySelect)
);
